import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Mixpanel from '../shared/Mixpanel';
import PixelExport from './PixelExport';

const GeneratePixelsButton = ({
  getCreatives,
  hideModal,
  modalOpen,
  showModal
}) => {
  const onClick = () => {
    showModal();
    Mixpanel.track('Opened 2.3 Export Modal');
  };

  return (
    <Fragment>
      <button
        className="btn btn-primary dsp-export pl1 pr1 mr1"
        onClick={onClick}
      >
        <i className="material-icons small-icon">file_download</i>
        Generate Pixels
      </button>
      <PixelExport
        getCreatives={getCreatives}
        hideModal={hideModal}
        modalOpen={modalOpen}
      />
    </Fragment>
  );
};

GeneratePixelsButton.propTypes = {
  getCreatives: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  showModal: PropTypes.func.isRequired
};

export default GeneratePixelsButton;
